module.exports = __webpack_public_path__ + "img/radio-melbourne.ecc2ad82.png";